import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl, InputLabel, InputAdornment, OutlinedInput, FormControlLabel, Checkbox, ButtonGroup,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import PageTitle from "../components/PageTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {PrintOutlined, RemoveRedEye} from "@mui/icons-material";
import copyObject from "../utils/copyObject";
import Paper from "@mui/material/Paper";
import {
    useLazyPracticesRetakesStatisticsWebReportQuery
} from "../store/reports/reportsApi";
import {useGetSemestersQuery} from "../store/system/systemApi";

export default function PracticesRetakesStatisticsWebReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {data: semestersData} = useGetSemestersQuery();
    const [dataRequest] = useLazyPracticesRetakesStatisticsWebReportQuery();
    const [data, setData] = useState([]);
    const [selectedSemesterId, setSelectedSemesterId] = useState([]);
    
    useEffect(() => {
        loadData();
    }, [])

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const loadData = async () => {
        setIsSaving(true);

        await dataRequest().unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setData(copyObject(fulfilled.faculties))
                console.log(fulfilled);
            } else {
                fulfilled.errors?.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch((e) => {
            alert('Ошибка');
            setIsSaving(false);
        });
    };

    function downloadReport(fileType) {
        setIsLoading(true);
        fetch(`/Reports/PracticesRetakesStatisticsPrintableReport?fileType=${fileType}`,
            {
                method: "GET",
                headers: {
                    "semesterid": localStorage.getItem("selectedSemesterId"),
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            if (response.size === 0) {
                alert('Не удалось загрузить файл')
                return;    
            }
            
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Статистика пересдач по практикам.${fileType}`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }).catch((e) => {
            alert('Ошибка')
        })
    }
    
    return (
        <GeneralLayout>
            <PageTitle title={`Статистика пересдач по практикам`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {isSaving ? <CircularProgress /> : <></>}
                            Статистика пересдач по практикам
                        </Typography>
                        
                        <ButtonGroup
                            size={'small'}
                            variant={'outlined'}>
                            <Button startIcon={isLoading ? <CircularProgress size={15}/> : <PrintOutlined />}
                                    disabled={isLoading}
                                    onClick={() => {downloadReport('pdf')}}>Печать PDF</Button>

                            <Button startIcon={isLoading ? <CircularProgress size={15}/> : <></>}
                                    disabled={isLoading}
                                    onClick={() => {downloadReport('xlsx')}}>XLSX</Button>
                        </ButtonGroup>
                    </Stack>

                    <Card>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2}>Вид, тип практики</TableCell>
                                    <TableCell rowSpan={2}>Преподаватели</TableCell>
                                    <TableCell colSpan={4} align={'center'}>Сведения о ведомости</TableCell>
                                    <TableCell rowSpan={2}>Группа</TableCell>
                                    <TableCell sx={{pl: 0}} rowSpan={2}>Ссылка</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>№ Ведомости</TableCell>
                                    <TableCell>Дата начала</TableCell>
                                    <TableCell>Дата завершения</TableCell>
                                    <TableCell>Период проведения</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.sort((l, r) => l.facultyName > r.facultyName ? 1 : -1).map((faculty) => {
                                    return <>
                                        <TableRow>
                                            <TableCell colSpan={8} align={'center'}>
                                                <strong>Факультет {faculty.facultyName}</strong>
                                            </TableCell>
                                        </TableRow>
                                        {faculty.rows?.sort((l, r) => l.groupName > r.groupName ? 1 : -1).map((row) => {
                                            return <TableRow>
                                                <TableCell>{row.practiceKind} {row.practiceType}</TableCell>
                                                <TableCell>{row.employees.join(', ')}</TableCell>
                                                <TableCell>№{row.statementNumber}</TableCell>
                                                <TableCell>{toDateString(row.creationDate)}</TableCell>
                                                <TableCell>{row.closingDate ? toDateString(row.closingDate) : 'Ведомость не закрыта'}</TableCell>
                                                <TableCell>{toDateString(row.from)} - {toDateString(row.to)}</TableCell>
                                                <TableCell>{row.groupName}</TableCell>
                                                <TableCell>
                                                    {row.statementNumber ? (
                                                        <a href={`/practice-statement-results/${row.statementId}`} target="_blank" rel="noopener noreferrer">ℹ️</a>
                                                    ) : (
                                                        '—'
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </>
                                })}
                            </TableBody>
                        </Table>
                    </Card>

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
